import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, MessageCircleHeartIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    age: '38 años',
    city: 'Miami, FL',
    quote: 'Llevaba 3 años con el abdomen hinchado sin importar lo que comía. En la segunda semana noté que mis pantalones me quedaban diferente. No lo podía creer.'
  }, {
    name: 'Carmen Reyes',
    age: '42 años',
    city: 'Houston, TX',
    quote: 'Siempre pensé que era normal sentirme así después de los 30. El ritual de 3 minutos antes de dormir cambió completamente cómo amanezco. Mi vientre por fin se ve plano en las mañanas.'
  }, {
    name: 'Lucía Mendoza',
    age: '35 años',
    city: 'Los Ángeles, CA',
    quote: 'Lo hice con dudas porque ya había probado de todo. A los 10 días mi esposo me preguntó qué estaba haciendo diferente. Eso me dijo todo.'
  }, {
    name: 'Patricia Herrera',
    age: '44 años',
    city: 'Chicago, IL',
    quote: 'No tenía tiempo para rutinas largas. Tres minutos en la cama antes de dormir era exactamente lo que necesitaba. Mi digestión mejoró y el abdomen bajó notablemente.'
  }, {
    name: 'Sofía Vargas',
    age: '39 años',
    city: 'Dallas, TX',
    quote: 'Después de mis dos embarazos sentía que mi cuerpo nunca volvería a ser el mismo. Este protocolo me devolvió la confianza. Me vuelvo a ver al espejo sin esconderme.'
  }];
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-316">
      <div className="max-w-5xl mx-auto px-4" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-12 md:mb-16" data-id="element-318">
          <span className="inline-flex items-center gap-2 text-[#C4A962] text-sm font-medium uppercase tracking-wider mb-4" data-id="element-319">
            <MessageCircleHeartIcon className="w-4 h-4" data-id="element-320" />
            Historias de Éxito
            <MessageCircleHeartIcon className="w-4 h-4" data-id="element-321" />
          </span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D3436] mb-4" data-id="element-322">
            Mujeres reales. Resultados reales.
          </h2>
          <p className="text-lg text-[#2D3436]/70 max-w-2xl mx-auto" data-id="element-323">
            Descubre cómo el protocolo ha transformado la vida de cientos de
            mujeres que, como tú, buscaban una solución definitiva.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-324">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white rounded-2xl p-8 shadow-md border border-[#2D3436]/5 flex flex-col h-full ${index === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-325">
              <div className="flex gap-1 mb-6" data-id="element-326">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-327" />)}
              </div>

              <blockquote className="flex-grow mb-8" data-id="element-328">
                <p className="text-lg text-[#2D3436]/80 italic leading-relaxed" data-id="element-329">
                  "{testimonial.quote}"
                </p>
              </blockquote>

              <div className="mt-auto pt-6 border-t border-[#2D3436]/10" data-id="element-330">
                <p className="font-bold text-[#2D3436] text-lg" data-id="element-331">
                  {testimonial.name},{' '}
                  <span className="font-normal text-[#2D3436]/70" data-id="element-332">
                    {testimonial.age}
                  </span>
                </p>
                <p className="text-sm text-[#2D3436]/50 mt-1 uppercase tracking-wide" data-id="element-333">
                  {testimonial.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}